import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import api from '../services/api';

interface PilotServiceLinkProps {
  text: string;
  icon: React.ReactNode;
  servicePath: string;
  collapsed?: boolean;
  onClick?: () => void;
}

const PilotServiceLink: React.FC<PilotServiceLinkProps> = ({ 
  text, 
  icon, 
  servicePath, 
  collapsed = false,
  onClick 
}) => {
  const navigate = useNavigate();

  const handleServiceAccess = async () => {
    console.log('[PilotServiceLink] Attempting to navigate to:', servicePath);
    try {
      // Get or create service access for the pilot
      const response = await api.get('/service-auth/pilot-service-access');
      
      // Store the service token for seamless access
      localStorage.setItem('serviceToken', response.data.service_token);
      localStorage.setItem('serviceUserId', response.data.service_user_id);
      localStorage.setItem('serviceUserEmail', response.data.email);
      localStorage.setItem('serviceUserNickname', response.data.nickname);
      localStorage.setItem('serviceUserData', JSON.stringify({
        id: response.data.service_user_id,
        email: response.data.email,
        nickname: response.data.nickname,
        name: response.data.nickname,
        phone: response.data.phone,
        service_tier: 'premium',
        has_premium_access: true,
        token: response.data.service_token,
      }));
      
      console.log('[PilotServiceLink] Service auth successful, navigating to:', servicePath);
      // Navigate to the service
      navigate(servicePath);
      
      // Call onClick if provided (for closing mobile drawer)
      if (onClick) {
        onClick();
      }
    } catch (error) {
      console.error('[PilotServiceLink] Failed to access service:', error);
      // Fallback to regular navigation if there's an error
      console.log('[PilotServiceLink] Fallback navigation to:', servicePath);
      navigate(servicePath);
      if (onClick) {
        onClick();
      }
    }
  };

  if (collapsed) {
    return (
      <Tooltip title={text} placement="right">
        <ListItemButton
          onClick={handleServiceAccess}
          sx={{
            borderRadius: 2,
            mb: 1,
            justifyContent: 'center',
            '&:hover': {
              bgcolor: 'primary.light',
              color: 'white',
              '& .MuiListItemIcon-root': {
                color: 'white',
              },
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 0 }}>{icon}</ListItemIcon>
        </ListItemButton>
      </Tooltip>
    );
  }

  return (
    <ListItemButton
      onClick={handleServiceAccess}
      sx={{
        borderRadius: 2,
        mb: 1,
        '&:hover': {
          bgcolor: 'primary.light',
          color: 'white',
          '& .MuiListItemIcon-root': {
            color: 'white',
          },
        },
      }}
    >
      <ListItemIcon sx={{ minWidth: 40 }}>{icon}</ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  );
};

export default PilotServiceLink;